import { notification } from "antd";
import { AuthorizedApiService } from "../../../services/apiServices";
import { GET_COMPANIES, SET_COMPANY_SCORING } from "./types";
import { NavigationPath } from "../../../helpers/constants";
import { formatNumber } from "../../../helpers/formater";

export const createOffer = (offer) => async (dispatch) => {
  console.log(offer);
  try {
    AuthorizedApiService.post("offer", offer).then((res) => {
      console.log(res);
      if (res.status !== 201) {
        notification.error({
          message: "Invalid Offer!",
        });
        return;
      }

      notification.success({
        message: "Offer created!",
      });
      window.location = NavigationPath.OFFERS_ROUTE;
    });
  } catch (err) {
    console.log(err);
  }
};

export const createClient = (client) => async (dispatch) => {
  try {
    console.log(client);
    AuthorizedApiService.post("client", client)
      .then((res) => {
        if (res.status !== 201) {
          notification.error({
            message: "Invalid!",
          });
          return;
        }

        notification.success({
          message: "Client created!",
        });
      })
      .catch(
        (err) => console.log(err),
        notification.error({
          message: "Invalid!",
        })
      );
  } catch (err) {
    console.log(err);
  }
};

export const getCompanies =
  (searchTerm = null) =>
  async (dispatch) => {
    try {
      AuthorizedApiService.get(`afipdata`, { params: { searchTerm } })
        .then((res) => {
          const { status, data } = res;
          if (status !== 200) {
            notification.error({
              message: "Something went wrong,can not get companies!",
            });
            return;
          }
          dispatch({
            type: GET_COMPANIES,
            payload: data,
          });
        })
        .catch((err) => {
          console.log(err);
          notification.error({
            message: "Something went wrong,can not get companies!",
          });
        });
    } catch (error) {
      console.log(error);
    }
  };

export const getScoringForCompany = (companyId) => async (dispatch) => {
  try {
    AuthorizedApiService.get(`scoring/${companyId}`)
      .then((res) => {
        const { status, data } = res;
        if (status !== 200) {
          notification.error({
            message: "Something went wrong,can not get companies!",
          });
          return;
        }
        console.log("data", data);
        const scoring = {
          ...data,
          ["OČEKIVANI EBITDA"]: formatNumber(data["OČEKIVANI EBITDA"]),
          ["INDIKATOR KAPITALA"]: (data["INDIKATOR KAPITALA"] * 100).toFixed(2),
        };

        dispatch({
          type: SET_COMPANY_SCORING,
          payload: scoring,
        });
      })
      .catch((err) => {
        console.log(err);
        notification.error({
          message: "Something went wrong,can not get companies!",
        });
      });
  } catch (error) {
    console.log(error);
  }
};
